/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsComponentProductQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AppSecopsComponentProductQueryOperator");
    }

    getFixupPrototypeFunction() { return AppSecopsComponentProductQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsComponentProductQueryOperator>): AppSecopsComponentProductQueryOperator {
        let obj = Object.assign(new AppSecopsComponentProductQueryOperator(), model);
        AppSecopsComponentProductQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsComponentProductQueryOperator>): AppSecopsComponentProductQueryOperator {
        if (!model) return null;
        return AppSecopsComponentProductQueryOperator.newInstance(<AppSecopsComponentProductQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsComponentProductQueryOperator) {
        if (!obj) return;

        models.AppSecopsComponentProductQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsComponentProductQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsComponentProductQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Component product(s)to include
     */
    products: Array<string>;

}
